import { useContext } from 'react';

import { UiContext } from '../context/UiContext';

export default function useUiContext() {
  const context = useContext(UiContext);

  return context;
}
